// Slot machine class
//
// Used to create, spin and animate reels as a group
// Contains no logic.
//
// Add this class to config.json under the "controllers" section, telling it which reels it is managing
//      "controllers": {
//        "slotMachine": { "reels": [ "reel0", "reel1", "reel2", "reel3", "reel4"]}
//      }
//
// addInjectors - adds to a list of injector pre/post pairs
// selectInjectors - selects the injector pre/post pair defined in addInjectors
// setInjectors - sets injector pre/post pairs now
//
// infiniteSpin - starts the reels infinitely spinning
// stopReels - signals reels that are infinitely spinning to stop on positions
//

// For backward compatibility
slotMachine = undefined;

slotMachineFactory = {};
slotMachineFactory.slotMachines = [];

slotMachineFactory.createSlotMachine = function () {
  var newSlotMachine = {};
  newSlotMachine.reels = [];
  newSlotMachine.activeReelMode = "";
  newSlotMachine.reelMode = {};
  newSlotMachine.groupAnalysers = {};
  newSlotMachine.symbolCreationCallbacks = {};
  newSlotMachine.slamStopRequested = false;

  newSlotMachine.addReel = function (reelId) {
    if (resourceManager.get(reelId).Props.type !== "infiniReel") {
      console.error(
        "slotMachine can only manage 'infiniReels', " +
          reelId +
          " is type '" +
          resourceManager.get(reelId).Props.type +
          "'"
      );
      return;
    }

    var reel = resourceManager.get(reelId);
    reel.reelIndex = this.reels.length;
    this.reels.push(reel);
  };

  newSlotMachine.initialise = function (json) {
    this.saveStateEverySpin = true;
    if (json.revertBackToDefaultReelsOnAbort) {
      this.saveStateEverySpin = false;
    }

    var containerName = json.containerName;
    var stripContainer = resourceManager.hasResource(
      containerName + ":reelStripContainer"
    )
      ? resourceManager.get(containerName + ":reelStripContainer")
      : undefined;
    var boxContainer = resourceManager.hasResource(
      containerName + ":reelBoxContainer"
    )
      ? resourceManager.get(containerName + ":reelBoxContainer")
      : undefined;

    for (var i = 0; i < json.reels.length; ++i) {
      this.addReel(containerName + ":reelContainer:" + json.reels[i]);

      if (stripContainer !== undefined) {
        stripContainer.addChild(this.reels[i].animationStripContainer);
      }

      if (boxContainer !== undefined) {
        boxContainer.addChild(this.reels[i].animationBoxContainer);
      }
    }

    for (var i = 0; i < json.injectors.length; ++i) {
      var injectorData = json.injectors[i];
      var modeName = injectorData.name;
      if (checkForDefined(this.reelMode[modeName])) {
        console.error("Reel mode " + modeName + " already defined");
        continue;
      }

      this.reelMode[modeName] = { injectorData: injectorData };
    }

    if (json.groupAnalysers !== undefined) {
      for (var i = 0; i < json.groupAnalysers.length; ++i) {
        var analyserData = json.groupAnalysers[i];
        this.groupAnalysers[analyserData.name] = new GroupAnalyser(
          analyserData.rules
        );
      }
    }
  };

  newSlotMachine.selectReelMode = function (modeName) {
    var reelMode = this.reelMode[modeName];
    if (checkForUndefined(reelMode)) {
      console.error("Reel mode " + name + " is not defined");
      return;
    }

    this.activeReelMode = modeName;
    this.setInjectors(reelMode.injectorData);
  };

  newSlotMachine.setInjectors = function (injectorData) {
    if (
      checkForUndefined(
        injectorData,
        "injectorData is not defined in the slotMachine",
        true
      )
    ) {
      return;
    }

    for (var i = 0; i < this.reels.length; ++i) {
      this.reels[i].setInjectors(
        new PreInjector(injectorData, this.symbolCreationCallbacks),
        new PostInjector(injectorData, this.symbolCreationCallbacks)
      );
    }
  };

  newSlotMachine.saveState = function () {
    // Save state on all reels and injectors
    for (var i = 0; i < this.reels.length; ++i) {
      this.reels[i].saveState();
      this.reels[i].preInjector.saveState();
      this.reels[i].postInjector.saveState();
    }
  };

  newSlotMachine.infiniteSpin = function (stopOffsets) {
    newSlotMachine.slamStopRequested = false;

    if (
      checkForUndefined(
        stopOffsets,
        "stopOffsets is not defined in slotMachine",
        true
      )
    ) {
      return;
    }

    if (this.reels.length !== stopOffsets.length) {
      console.error(
        "Number of reels configured for slot machine (" +
          this.reels.length +
          ") is different to number of stopOffsets (" +
          stopOffsets.length +
          ")"
      );
      return;
    }

    if (this.saveStateEverySpin) {
      this.saveState();
    }

    this.stopOffsets = stopOffsets;
    this.minDistance = Math.min.apply(Math, stopOffsets);

    for (var i = 0; i < this.reels.length; ++i) {
      this.reels[i].infiniteSpin(this.minDistance);
    }
  };

  newSlotMachine.slamStop = function (offsets) {
    newSlotMachine.slamStopRequested = true;

    this.stopOffsets = offsets;
    for (var i = 0; i < this.stopOffsets.length; ++i) {
      if (this.stopOffsets[i] === 0) {
        var reel = this.reels[i];
        reel.preInjector.forceStop();
        reel.requestSlamStop();
      }
    }
  };

  newSlotMachine.stopReels = function (
    abovePositions,
    positions,
    belowPositions,
    postApperturePadding
  ) {
    var allLandingSymbols = [];
    for (var i = 0; i < positions.length; ++i) {
      if (positions[i] === undefined) {
        allLandingSymbols.push(undefined);
      } else {
        allLandingSymbols.push(positions[i].slice());
      }
    }

    // Validate data sizes
    if (this.reels.length !== allLandingSymbols.length) {
      console.error(
        "Number of reels configured for slot machine (" +
          this.reels.length +
          ") is different to number of reel positions (" +
          allLandingSymbols.length +
          ")"
      );
      return;
    }

    for (var i = 0; i < this.reels.length; ++i) {
      if (allLandingSymbols[i] !== undefined) {
        if (
          this.reels[i].configParams.appertureHeight !==
          allLandingSymbols[i].length
        ) {
          console.error(
            "Number of rows configured for slot " +
              this.reels[i].Props.FQN +
              " (" +
              this.reels[i].configParams.appertureHeight +
              ") is different to number of rows in positions (" +
              allLandingSymbols[i].length +
              ")"
          );
          return;
        }
      }
    }

    // Merge in above symbols
    if (abovePositions !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        for (var j = abovePositions[i].length - 1; j >= 0; --j) {
          allLandingSymbols[i].unshift(abovePositions[i][j]);
        }
      }
    }
    // Merge in below symbols
    if (belowPositions !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        for (var j = 0; j < belowPositions[i].length; ++j) {
          allLandingSymbols[i].push(belowPositions[i][j]);
        }
      }
    }

    // Analyse the landing symbols for groups
    var analyser = this.groupAnalysers[this.activeReelMode];
    if (analyser !== undefined) {
      for (var i = 0; i < this.reels.length; ++i) {
        if (allLandingSymbols[i] === undefined) {
          continue;
        }

        //Set the analyser to use reverse spin logic
        analyser.isReverseSpin = this.reels[i].spinParams.reverseSpin;

        if (
          analyser.analyse(allLandingSymbols[i], this.reels[i].postInjector)
        ) {
          //Update landing position data
          var aboveSlice = { start: 0, end: abovePositions[i].length };
          var positionsSlice = {
            start: aboveSlice.end,
            end: aboveSlice.end + positions[i].length,
          };
          var belowSlice = {
            start: positionsSlice.end,
            end: positionsSlice.end + belowPositions[i].length,
          };

          abovePositions[i] = allLandingSymbols[i].slice(
            aboveSlice.start,
            aboveSlice.end
          );
          positions[i] = allLandingSymbols[i].slice(
            positionsSlice.start,
            positionsSlice.end
          );
          belowPositions[i] = allLandingSymbols[i].slice(
            belowSlice.start,
            belowSlice.end
          );
        }
      }
    }

    // Check if one of the pre-injectors has an unfinished group, if it does then we need to ensure that
    // all the reels can accomodate the extra post-apperature symbols
    // Also make sure to check if the postInjector wants to add an additional group
    var requiredGroupSymbols = 0;
    for (var i = 0; i < this.reels.length; ++i) {
      var landOffset = this.reels[i].preInjector.requiredSymbols.length;
      landOffset = Math.max(
        this.reels[i].postInjector.postSymbols.length,
        landOffset
      );
      requiredGroupSymbols = Math.max(requiredGroupSymbols, landOffset);
    }

    // Check symbol distancing rules
    var requiredSymbolDistancing = 0;
    for (var i = 0; i < this.reels.length; ++i) {
      if (allLandingSymbols[i] === undefined) {
        continue;
      }

      var reel = this.reels[i];
      var symbolData = reel.symbolData;
      var preInjector = reel.preInjector;
      var postInjector = reel.postInjector;
      var bounceSymbols = postInjector.bounceSymbols;
      var landingSymbols = allLandingSymbols[i];
      var requiredSymbols = preInjector.requiredSymbols;

      for (
        var symInViewIndex = 0;
        symInViewIndex < symbolData.length;
        ++symInViewIndex
      ) {
        var reelSymbol = symbolData[symInViewIndex].symbolId;
        for (
          var bounceSymIndex = 0;
          bounceSymIndex < bounceSymbols.length;
          ++bounceSymIndex
        ) {
          var distanceRequired = preInjector.base.getDistanceToNext(
            bounceSymbols[bounceSymIndex],
            reelSymbol
          );
          requiredSymbolDistancing = Math.max(
            requiredSymbolDistancing,
            distanceRequired
          );
        }

        for (
          var landingSymIndex = 0;
          landingSymIndex < landingSymbols.length;
          ++landingSymIndex
        ) {
          var distanceRequired = preInjector.base.getDistanceToNext(
            landingSymbols[landingSymIndex],
            reelSymbol
          );
          requiredSymbolDistancing = Math.max(
            requiredSymbolDistancing,
            distanceRequired
          );
        }

        for (
          var requiredSymIndex = 0;
          requiredSymIndex < requiredSymbols.length;
          ++requiredSymIndex
        ) {
          var distanceRequired = preInjector.base.getDistanceToNext(
            requiredSymbols[requiredSymIndex],
            reelSymbol
          );
          requiredSymbolDistancing = Math.max(
            requiredSymbolDistancing,
            distanceRequired
          );
        }
      }
    }

    if (postApperturePadding === undefined) {
      postApperturePadding = 0;
    }

    // Signal all reels to stop
    for (var i = 0; i < this.reels.length; ++i) {
      var reel = this.reels[i];
      if (positions[i] === undefined) {
        reel.postInjector.setLandingData(undefined);
        continue;
      }

      var configParams = reel.configParams;
      var spinReversed = reel.spinParams.reverseSpin;
      var preappertureSymbols = configParams.preappertureSymbols;
      var postappertureSymbols =
        this.stopOffsets[i] -
        this.minDistance +
        requiredGroupSymbols +
        requiredSymbolDistancing +
        configParams.postappertureSymbols +
        postApperturePadding;

      var landingData = {
        preappertureSymbols: preappertureSymbols,
        aboveLandingSymbols:
          abovePositions === undefined ? undefined : abovePositions[i],
        landingSymbols: positions[i],
        belowLandingSymbols:
          belowPositions === undefined ? undefined : belowPositions[i],
        postappertureSymbols: postappertureSymbols,
        reverseSpin: spinReversed,
      };

      var totalPostInjectorSymbols =
        landingData.preappertureSymbols +
        reel.Props.appertureHeight +
        landingData.postappertureSymbols;
      if (totalPostInjectorSymbols < reel.spinParams.decelerationDistance) {
        console.warn(
          "Reel " +
            i +
            " has a deceleration distance of " +
            reel.spinParams.decelerationDistance +
            " symbols, but only " +
            totalPostInjectorSymbols +
            " symbols are in the post injector."
        );
        reel.spinParams.decelerationDistance =
          landingData.preappertureSymbols +
          reel.Props.appertureHeight +
          landingData.postappertureSymbols;
      }

      reel.postInjector.setLandingData(landingData);
      reel.requestStop();
    }

    // Wait until all reels are ready to stop
    Reflex.addToUpdate(this.checkForStopReels);
  };

  newSlotMachine.checkForStopReels = function () {
    for (var i = 0; i < newSlotMachine.reels.length; ++i) {
      if (
        !newSlotMachine.slamStopRequested &&
        !newSlotMachine.reels[i].preInjector.canStop
      ) {
        return;
      }
    }

    // We can stop the reels
    for (var i = 0; i < newSlotMachine.reels.length; ++i) {
      var reel = newSlotMachine.reels[i];
      if (reel.postInjector.hasLandingSymbols) {
        reel.stop();
        reel.postInjector.createLandingSymbols(
          reel.symbolData,
          reel.preInjector.requiredSymbols,
          reel.preInjector.symbolsLastDrawn
        );
      }
    }

    Reflex.removeFromUpdate(newSlotMachine.checkForStopReels);
  };

  slotMachineFactory.slotMachines.push(newSlotMachine);
  if (slotMachineFactory.slotMachines.length === 1) {
    // This is the first slot machine, so assign it to the global variable
    slotMachine = newSlotMachine;
  }

  return newSlotMachine;
};

slotMachineFactory.onAbortGame = function () {
  // Retore state on all reels and injectors
  for (
    var slotMachineIndex = 0;
    slotMachineIndex < slotMachineFactory.slotMachines.length;
    slotMachineIndex++
  ) {
    var slotMachine = slotMachineFactory.slotMachines[slotMachineIndex];
    for (var i = 0; i < slotMachine.reels.length; ++i) {
      slotMachine.reels[i].restoreState();
      slotMachine.reels[i].preInjector.restoreState();
      slotMachine.reels[i].postInjector.restoreState();
    }
  }
};

slotMachineFactory.getSlotMachine = function (id) {
  if (typeof id === "number") {
    // This is an index
    return slotMachineFactory.slotMachines[id];
  } else {
    // This is a name
    for (var i = 0; i < slotMachineFactory.slotMachines.length; i++) {
      if (slotMachineFactory.slotMachines[i].name === id)
        return slotMachineFactory.slotMachines[i];
    }

    console.log("Slot machine " + id + " was not found");
    return undefined;
  }
};

resourceManager.registerController(
  "slotMachine",
  slotMachineFactory.createSlotMachine
);
messageBus.subscribe("common:AbortGame", slotMachineFactory.onAbortGame);
